import { Route } from '@angular/router';
import { ErrorPagesWrapperComponent, ErrorPageType } from '@flexbenefits-ui/ui-components';
import { authGuard } from '@flexbenefits-ui/guards';

const accessDenied: ErrorPageType = 'AccessDenied';
const pageNotFound: ErrorPageType = 'PageNotFound';
const techDifficulties: ErrorPageType = 'TechDifficulties';

export const appRoutes: Route[] = [
    {
        path: 'denied',
        component: ErrorPagesWrapperComponent,
        data: { errorPageType: accessDenied, isMobile: false },
    },
    {
        path: '',
        canActivate: [authGuard],
        loadComponent: () => import('@flexbenefits-ui/feature-flexbenefits').then(m => m.BenefitListComponent)
    },
    {
        path: 'admin/products',
        canActivate: [authGuard],
        loadComponent: () => import('@flexbenefits-ui/feature-admin').then(m => m.ProductManagementComponent)
    },
    {
        path: 'benefits',
        canActivate: [authGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: '/'
            },
            // Dynamic route: productName in URL, productId passed via router state
            {
                path: 'request/:productName',
                canActivate: [authGuard],
                loadComponent: () => import('@flexbenefits-ui/feature-flexbenefits').then(m => m.ProductRequestDynamicComponent)
            },
            {
                path: 'denied',
                component: ErrorPagesWrapperComponent,
                data: {
                    errorPageType: accessDenied,
                    isMobile: false,
                },
            },
            {
                path: 'technicalDifficulties',
                component: ErrorPagesWrapperComponent,
                data: { errorPageType: techDifficulties, isMobile: false },
            },
            {
                path: '**',
                component: ErrorPagesWrapperComponent,
                data: {
                    errorPageType: pageNotFound,
                    isMobile: false,
                },
            },
        ]
    }
];
